import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface FormSectionProps {
  icon?: IconDefinition;
  title?: string;
  description?: string;
  testId?: string;
}

const FormSection: FunctionComponent<FormSectionProps> = ({
  icon,
  title,
  description,
  testId,
  children,
}) => (
  <Flex
    sx={{
      flexDirection: 'column',
      gap: 'xl',
      width: '100%',
      pb: 'xl',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: 't.black20',
    }}
    data-testid={testId}
  >
    {(icon || title || description) && (
      <Flex
        sx={{
          flexDirection: 'column',
          gap: 'xs',
          width: '100%',
          color: 't.black70',
          fontWeight: 400,
          lineHeight: 'normal',
        }}
      >
        {(icon || title) && (
          <Flex sx={{ alignItems: 'center', gap: 'xs', pt: 'xxs', pb: 'xxs' }}>
            {icon && (
              <Box sx={{ color: 't.black80', fontSize: '22px' }}>
                <FontAwesomeIcon icon={icon} />
              </Box>
            )}
            {title && (
              <Box sx={{ fontWeight: 600, fontSize: 'H500' }}>{title}</Box>
            )}
          </Flex>
        )}
        {description && (
          <Box sx={{ fontSize: 'H300', whiteSpace: 'pre-line' }}>
            {description}
          </Box>
        )}
      </Flex>
    )}
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 'xl',
      }}
    >
      {children}
    </Box>
  </Flex>
);

export default FormSection;
